import type { SubjectType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

export function obtainUIDs(source?: Array<{ uid: string; waveUid?: string }>) {
  // seeking for unique uids
  return [...new Set((source || []).map(v => (!v.waveUid || v.uid === v.waveUid ? v.uid : v.waveUid)))]
}

export function subjectUidsToWaveUids(
  uids: null | Array<string>,
  subjects: null | Record<string, SubjectType>
): Set<string> {
  return (
    uids?.reduce((acc: Set<string>, uid: string) => {
      acc.add(subjects?.[uid]?.waveUid)
      return acc
    }, new Set()) || new Set()
  )
}
